import ShipmentContract from "./shipmentContract";
import InvoiceDataContract from "./invoiceDataContract";

/**
 * @param {string} id
 * @constructor
 */
function CartContract(id) {
    /**
     * @type {string}
     */
    this.cartId = id;
    /**
     * @type {number}
     */
    this.activeStep = 0;

    /**
     * @type {Map<String, CartItemContract>}
     */
    this.items = {};

    /**
     * @type {Array<string>}
     */
    this.designs = [];

    /**
     * @type {Map<string, number>}
     */
    this.selectedDesigns = {};

    /**
     * @type {InvoiceDataContract}
     */
    this.invoiceData = new InvoiceDataContract();

    /**
     * @type {ShipmentContract}
     */
    this.shipping = new ShipmentContract();

    /**
     * @type {string}
     */
    this.paymentType = 'creditCard';

    /**
     * @type {string}
     */
    this.promoCode = '';
}

export default CartContract;